import { Drawer, Table, Tag, Icon, Divider, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";


let dateFormat = localStorage.getItem('company-details')
    ? JSON.parse(localStorage.getItem('company-details')).dateFormat
    : 'DD.MM.YYYY';

class CallRegisterDetails extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    }

    render() {
        let calls = this.props.calls || { total: 0, data: [] };
        // let { total, data } = calls;
        let { count, data, bgColorClass, icon, title } = this.props.drawerParam;
        const column = [
            {
                title: 'Caller Name',
                key: 'name',
                width: '25%',
                render: (_, record) => {
                    var showVid = record.vid !== undefined && record.vid !== null && record.vid !== 0;
                    return (
                        <div>
                            <div style={{ fontWeight: 700, color: "#1a3353" }}>
                                {record.name || 'Unknown'}
                            </div>

                            {showVid && (
                                <Tag style={{ width: 'fit-content', fontSize: '10px', borderRadius: '4px' }}>
                                    ID: {record.vid}
                                </Tag>
                            )}
                        </div>
                    );
                }
            },
            {
                title: 'Contact',
                key: 'contact',
                render: (_, record) => (
                    <div style={{ fontSize: '13px' }}>
                        <div>
                            <Icon type="phone" style={{ color: '#52c41a', marginRight: 8 }} />
                            {(record.countryCode || '')} {record.phoneNo || 'N/A'}
                        </div>
                        <div style={{ marginTop: 4, color: '#555' }}>
                            <Icon type="mail" style={{ marginRight: 8 }} />
                            {record.email || "N/A"}
                        </div>
                    </div>
                )
            },
            {
                title: 'Call Status',
                dataIndex: 'callStatus',
                key: 'callStatus',
                render: status => (
                    <Tag color={status === 'Connected' ? 'green' : 'red'}>
                        {status || 'Unknown'}
                    </Tag>
                )
            },
            {
                title: 'Call Date',
                key: 'callDate',
                render: (_, record) => (
                    <div>
                        <Icon type="calendar" style={{ marginRight: 6 }} />
                        {record.callDate
                            ? moment(record.callDate).format(dateFormat + ' HH:mm A')
                            : '-'}
                    </div>
                )
            },
            {
                title: 'Call For',
                key: 'callFor',
                render: (_, record) => (
                    <div style={{ fontWeight: 600 }}>
                        {record.employeeId && record.employeeId.name || '-'}
                    </div>
                )
            },
            {
                title: 'Created By',
                key: 'created',
                align: 'right',
                render: (_, record) => {
                    var creator = 'System';
                    var time = '';

                    if (record.createdByUser) {
                        if (record.createdByUser.name) {
                            creator = record.createdByUser.name;
                        }
                        if (record.createdByUser.time) {
                            time = moment(record.createdByUser.time).format(dateFormat + ' HH:mm A');
                        }
                    }

                    return (
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 600 }}>{creator}</div>
                            <div style={{ fontSize: '11px', color: '#aaa' }}>{time}</div>
                        </div>
                    );
                }
            }
        ];
        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                width={1100}
                className={`dynamic-drawer ${bgColorClass}`} // This class triggers the CSS above
            >
                <Table
                    dataSource={data}
                    columns={column}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                    loading={this.state.loading}
                    rowKey={(record, index) => index}
                />
            </Drawer>
        );
    }
}

const mapDispatchToProps = dispatch => ({ dispatch });
export default connect(null, mapDispatchToProps)(CallRegisterDetails);